import { useMutation } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { z } from 'zod/v4';

import {
  type ApiError,
  type ApiResponse,
  addActionNameToMutationResult,
  useAxiosInstance,
} from './utils';

export const AcceptGcollectRatesVariablesSchema = z.object({
  thirdPartyCaseIds: z.array(z.number()),
  acceptRates: z.boolean(),
});

export type AcceptGcollectRatesVariables = z.infer<typeof AcceptGcollectRatesVariablesSchema>;

async function acceptGcollectRatesMutationFn(
  axiosInstance: Promise<AxiosInstance>,
  vars: AcceptGcollectRatesVariables,
) {
  const instance = await axiosInstance;

  const data = instance.post(
    'gcollect_cases/accept_rates',
    AcceptGcollectRatesVariablesSchema.parse(vars),
  );
  return data;
}

export function useAcceptGcollectRates() {
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, AcceptGcollectRatesVariables>({
    mutationFn: (vars: AcceptGcollectRatesVariables) =>
      acceptGcollectRatesMutationFn(axiosInstance, vars),
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    AcceptGcollectRatesVariables,
    'acceptGcollectRates'
  >('acceptGcollectRates', mutation);
}
